import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FileText, ExternalLink, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export default function ClientPortal() {
  const { token } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["portal", token],
    queryFn: async () => (await api.get(`/portal/${token}`)).data,
    retry: false,
  });

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center font-['Ubuntu']">Carregando...</div>;
  }
  if (isError || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center font-['Ubuntu']" data-testid="portal-not-found">
        Acesso não encontrado.
      </div>
    );
  }

  const contractLabel =
    data.contract_status === "signed" ? "Assinado" : data.contract_status === "sent" ? "Enviado — aguardando assinatura" : "Ainda não enviado";

  return (
    <div className="min-h-screen bg-[#FAFAF7] py-16 px-4" data-testid="client-portal-page">
      <div className="max-w-2xl mx-auto">
        <p className="font-['Ubuntu'] text-xs uppercase tracking-[0.25em] text-[#9B5DE5] font-bold mb-2">Bring Me Cash — Área do Cliente</p>
        <h1 className="font-['Cutive'] text-3xl font-bold mb-8" data-testid="portal-client-name">Olá, {data.name}</h1>

        <div className="border-2 border-black rounded-2xl p-6 bg-white mb-6">
          <h2 className="font-['Ubuntu'] font-bold mb-3 flex items-center gap-2"><FileText className="w-4 h-4" /> Contrato</h2>
          <p className="font-['Ubuntu'] text-sm text-black/60 mb-3" data-testid="portal-contract-status">
            Status: <span className="font-bold">{contractLabel}</span>
          </p>
          {data.contract_url && (
            <a
              href={data.contract_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-['Ubuntu'] font-bold text-sm border-2 border-black rounded-full px-4 py-2 hover:bg-black hover:text-white transition-colors"
              data-testid="portal-contract-link"
            >
              <ExternalLink className="w-4 h-4" /> Ver contrato
            </a>
          )}
        </div>

        <div className="border-2 border-black rounded-2xl p-6 bg-white">
          <h2 className="font-['Ubuntu'] font-bold mb-4">Seus acessos</h2>
          {data.pack_items?.length ? (
            <div className="space-y-3">
              {data.pack_items.map((item, i) => (
                <a
                  key={i}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between border-2 border-black/10 rounded-xl px-4 py-3 hover:border-black transition-colors"
                  data-testid={`portal-pack-item-${i}`}
                >
                  <span className="font-['Ubuntu'] font-medium flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-[#00F5D4]" /> {item.title}
                  </span>
                  <ExternalLink className="w-4 h-4" />
                </a>
              ))}
            </div>
          ) : (
            <p className="font-['Ubuntu'] text-sm text-black/50" data-testid="portal-empty">Nenhum item liberado ainda.</p>
          )}
        </div>
      </div>
    </div>
  );
}
